<template>
  <div class="col-12 py-2 d-flex">
    <div class="card flex-grow-1">
      <div class="card-body">
        <div class="table-responsive mb-0">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>#</th>
                <th
                  class="sortable-col"
                  :class="{ 'sort-active': sortColumn === 'nom' }"
                  @click="toggleSort('nom')"
                >
                  Nom <SortIconComponent column="nom" :sortColumn :sortDirection />
                </th>
                <th
                  class="sortable-col d-none d-md-table-cell"
                  :class="{ 'sort-active': sortColumn === 'email' }"
                  @click="toggleSort('email')"
                >
                  Email <SortIconComponent column="email" :sortColumn :sortDirection />
                </th>
                <th
                  class="sortable-col d-none d-md-table-cell"
                  :class="{ 'sort-active': sortColumn === 'mobilePhone' }"
                  @click="toggleSort('mobilePhone')"
                >
                  Téléphone <SortIconComponent column="mobilePhone" :sortColumn :sortDirection />
                </th>
                <th
                  class="sortable-col"
                  :class="{ 'sort-active': sortColumn === 'statut' }"
                  @click="toggleSort('statut')"
                >
                  Statut <SortIconComponent column="statut" :sortColumn :sortDirection />
                </th>
                <th
                  class="sortable-col"
                  :class="{ 'sort-active': sortColumn === 'lien' }"
                  @click="toggleSort('lien')"
                >
                  Lien <SortIconComponent column="lien" :sortColumn :sortDirection />
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(participation, index) in participants" :key="index">
              <tr>
                <td><b>{{ participation.rank }}</b></td>
                <td>{{ `${(participation.userInfo??participation.user)?.lastName?.toUpperCase()} ${(participation.userInfo??participation.user)?.firstName}`.trim() }}</td>
                <td class="d-none d-md-table-cell">{{ (participation.userInfo??participation.user)?.email }}</td>
                <td class="d-none d-md-table-cell">{{ (participation.userInfo??participation.user)?.mobilePhone }}</td>
                <td>{{ GetUserStatusLabel((participation.userInfo??participation.user)?.status) }}</td>
                <td><ParticipantStatusLinkComponent :participation="participation" /></td>
              </tr>
              <template v-if="(filters?.hideCompanions ?? false) != true && (participation.companions?.length ?? 0) > 0">
                <tr v-for="(companion, index2) in participation.companions ?? []" :key="index2">
                  <td><b>{{ participation.rank }}</b></td>
                  <td><i class="fa-solid fa-user me-1"></i> {{ `${companion.lastName?.toUpperCase()} ${companion.firstName}`.trim() }}</td>
                  <td class="d-none d-md-table-cell">{{ companion.email }}</td>
                  <td class="d-none d-md-table-cell">{{ companion.mobilePhone }}</td>
                  <td>{{ GetUserStatusLabel(companion.status) }}</td>
                  <td><ParticipantStatusLinkComponent :participation="participation" /></td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue';
  import { GetUserStatusLabel } from '@/compositions/helper';
  import { useBoardFilters } from '@/compositions/useBoardFilters';
  import ParticipantStatusLinkComponent from '@/components/admin/ParticipantStatusLinkComponent.vue';
  import SortIconComponent from '@/components/common/SortIconComponent.vue';

  type SortColumnKey = 'nom' | 'email' | 'mobilePhone' | 'statut' | 'lien';
  type SortDirection = 'asc' | 'desc';

  const { participations, filters } = useBoardFilters({ })

  const sortColumn = ref<SortColumnKey>('nom');
  const sortDirection = ref<SortDirection>('asc');

  const toggleSort = (col: SortColumnKey) => {
    if (sortColumn.value === col) {
      if (sortDirection.value === 'asc') {
        sortDirection.value = 'desc';
      } else {
        sortColumn.value = 'nom';
        sortDirection.value = 'asc';
      }
    } else {
      sortColumn.value = col;
      sortDirection.value = 'asc';
    }
  };

  const getSortValue = (p: ParticipationDb, col: SortColumnKey): string => {
    const user = p.userInfo ?? p.user;
    switch (col) {
      case 'nom':
        return `${user?.lastName ?? ''} ${user?.firstName ?? ''}`.toLowerCase();
      case 'email':
        return (user?.email ?? '').toLowerCase();
      case 'mobilePhone':
        return (user?.mobilePhone ?? '').toLowerCase();
      case 'statut':
        return (GetUserStatusLabel(user?.status) ?? '').toLowerCase();
      case 'lien':
        return (p.invitation?.completionDate ? 'inscrit' : p.invitation?.sentDate ? 'envoye' : 'non-envoye').toLowerCase();
      default:
        return '';
    }
  };

  const participants = computed(() => {
    const col = sortColumn.value;
    const dir = sortDirection.value === 'asc' ? 1 : -1;

    const result = [...participations.value] as (ParticipationDb & { rank: number })[];
    let i = 0;
    result.forEach(p => {
      p.rank = ++i;
    })

    result.sort((a, b) => {
      const va = getSortValue(a as ParticipationDb, col);
      const vb = getSortValue(b as ParticipationDb, col);
      return va < vb ? -dir : va > vb ? dir : 0;
    });

    return result;
  });
</script>
